import { ACTIONS } from '../constants';

export const createNew = () => {
  return { type: ACTIONS.CREATE_NEW };
};

export const getDrivers = (worksheetId) => {
  return { payload: worksheetId, type: ACTIONS.GET_DRIVERS };
};

export const getPolicyholder = (worksheetId) => {
  return { payload: worksheetId, type: ACTIONS.GET_POLICYHOLDER };
};

export const getVehicleInformation = (worksheetId) => {
  return { payload: worksheetId, type: ACTIONS.GET_VEHICLE_INFORMATION };
};

export const selectBrand = () => {
  return { type: ACTIONS.SELECT_BRAND };
};

export const selectModel = () => {
  return { type: ACTIONS.SELECT_MODEL };
};

export const selectVersion = () => {
  return { type: ACTIONS.SELECT_VERSION };
};

export const updateDrivers = () => {
  return { type: ACTIONS.UPDATE_DRIVERS };
};

export const updatePolicyholder = () => {
  return { type: ACTIONS.UPDATE_POLICYHOLDER };
};

export const updateVehicleInformation = () => {
  return { type: ACTIONS.UPDATE_VEHICLE_INFORMATION };
};

export const vinRecognition = () => {
  return { type: ACTIONS.VIN_RECOGNITION };
};
